import { Controller } from "@hotwired/stimulus"

// เมนูแอดมินบนมือถือ (layouts/_admin_nav_mobile)
// - กดไอคอนหมวด → กางรายการใต้แถวนั้น กางทีละหมวด กดซ้ำเพื่อหุบ
// - "เปิดล่าสุด" จำ 4 หน้าล่าสุดในเครื่องนี้ (localStorage) ไม่ต้องเก็บฝั่งเซิร์ฟเวอร์
// - ตัวเปิด/ปิดเป็น checkbox-hack (CSS ล้วน) — คีย์บอร์ดกับ screen reader เข้าไม่ถึงเอง
//   เลยเติมที่นี่: Enter/Space บนปุ่ม ☰, Escape ปิด, ย้าย focus เข้า-ออก, วน Tab ในเมนู
const KEY = "admin-nav-recent"
const MAX = 4

export default class extends Controller {
  static targets = ["recent", "chips"]

  connect() {
    this.remember()
    this.renderRecent()

    this.checkbox = document.getElementById("admin-menu-toggle")
    this.menuBtn = document.querySelector(".admin-menu-btn")
    if (!this.checkbox || !this.menuBtn) return

    this.onBtnKeydown = (e) => {
      if (e.key !== "Enter" && e.key !== " ") return
      e.preventDefault()
      this.menuBtn.click()
    }
    this.onToggle = () => {
      const open = this.checkbox.checked
      this.menuBtn.setAttribute("aria-expanded", String(open))
      if (open) this.focusables()[0]?.focus()
      else this.menuBtn.focus()
    }
    this.onDocKeydown = (e) => {
      if (!this.checkbox.checked) return
      if (e.key === "Escape") {
        this.menuBtn.click()
        return
      }
      // เมนูทึบเต็มจอ — วน Tab อยู่ใน ปุ่ม ✕ + รายการเมนู ไม่ให้หลุดไปเนื้อหาที่ถูกบัง
      if (e.key !== "Tab") return
      const ring = [this.menuBtn, ...this.focusables()]
      const i = ring.indexOf(document.activeElement)
      if (i === -1) return
      const next = ring[(i + (e.shiftKey ? -1 : 1) + ring.length) % ring.length]
      e.preventDefault()
      next.focus()
    }
    this.menuBtn.addEventListener("keydown", this.onBtnKeydown)
    this.checkbox.addEventListener("change", this.onToggle)
    document.addEventListener("keydown", this.onDocKeydown)
  }

  disconnect() {
    if (!this.checkbox || !this.menuBtn) return
    this.menuBtn.removeEventListener("keydown", this.onBtnKeydown)
    this.checkbox.removeEventListener("change", this.onToggle)
    document.removeEventListener("keydown", this.onDocKeydown)
  }

  focusables() {
    return [...this.element.querySelectorAll("a[href], button:not([disabled])")]
      .filter((el) => el.offsetParent !== null)
  }

  toggle(event) {
    const tile = event.currentTarget
    const key = tile.dataset.group
    const opening = !tile.classList.contains("is-open")

    this.element.querySelectorAll(".admin-launcher__tile.is-open").forEach((t) => {
      t.classList.remove("is-open")
      t.setAttribute("aria-expanded", "false")
    })
    this.element.querySelectorAll("[data-fold]").forEach((f) => { f.hidden = true })

    if (!opening) return
    tile.classList.add("is-open")
    tile.setAttribute("aria-expanded", "true")
    const fold = this.element.querySelector(`[data-fold="${key}"]`)
    fold.hidden = false
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    fold.scrollIntoView({ block: "nearest", behavior: reduce ? "auto" : "smooth" })
  }

  // หน้าที่เปิดอยู่ตอนนี้ (ถ้าอยู่ในเมนู) ขึ้นไปหัวแถว "เปิดล่าสุด"
  remember() {
    const here = this.element.querySelector(".admin-launcher__item[aria-current='page']")
    if (!here) return
    const entry = { label: here.dataset.label, path: here.getAttribute("href") }
    const list = [entry, ...this.load().filter((e) => e.path !== entry.path)].slice(0, MAX)
    try { localStorage.setItem(KEY, JSON.stringify(list)) } catch (_) { /* โหมดส่วนตัว — ข้ามไป */ }
  }

  renderRecent() {
    const list = this.load()
    if (list.length === 0) return
    const current = location.pathname
    // ป้ายในเมนูอาจถูกเปลี่ยนชื่อภายหลัง — ถ้า path ยังอยู่ในเมนู ใช้ป้ายสดจากเมนูแทนป้ายที่เคยเก็บไว้
    const fresh = {}
    this.element.querySelectorAll(".admin-launcher__item[data-label]").forEach((el) => {
      fresh[el.getAttribute("href")] = el.dataset.label
    })
    this.chipsTarget.replaceChildren(...list.map((e) => {
      const a = document.createElement("a")
      a.href = e.path
      a.textContent = fresh[e.path] || e.label
      a.className = "admin-launcher__chip"
      if (e.path === current) a.setAttribute("aria-current", "page")
      return a
    }))
    this.recentTarget.hidden = false
  }

  load() {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || "[]")
      return Array.isArray(list) ? list.filter((e) => e && e.label && e.path) : []
    } catch (_) {
      return []
    }
  }
}
